<template>
  <div :class="wrapClasses">
    <input
      ref="element"
      v-model="model"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="inputClasses"
      :no-warning="phoneType"
      :autofocus="autofocus"
      type="text"
      @keydown="$_onKeyDown"
      @change="$_onChange"
      @focus="$_onFocus"
      @blur="$_onBlur"
    />
  </div>
</template>

<script>
import NumeralFormatter from './utils/NumeralFormatter'
import DateFormatter from './utils/DateFormatter'
import TimeFormatter from './utils/TimeFormatter'
import PhoneFormatter from './utils/PhoneFormatter'
import CreditCardDetector from './utils/CreditCardDetector'
import Util from './utils/util'

import {
  PREFIX_CLASS
} from '@/utils/constants'
// NOTE: 因为没有引用库文件，所以需要默认引用常见的国家格式, 以下格式包含中国、香港、台湾、美国、日本、俄罗斯
// import CleavePhone from './addons/cleave-phone.i18n'
// eslint-disable-next-line
import * as phoneType from './addons/phone-type.i18n.js'
import Emitter from '../../mixins/emitter'
const PREFIXCLS = `${PREFIX_CLASS}input`

export default {
  name: 'TFormatInput',
  mixins: [Emitter],
  props: {
    value: {
      type: [ Number, String ],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      validator(value) {
        /* istanbul ignore next */
        return ['sm', 'lg', ''].includes(value)
      },
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // credit card
    creditCard: {
      type: Boolean,
      default: false
    },
    // 有些信用卡可以有多达19位的数字。将strictMode设置为true将移除16个最大长度限制
    creditCardStrictMode: {
      type: Boolean,
      default: true
    },
    // creditCardType: {
    //   type: String,
    //   default: ''
    // },
    // onCreditCardTypeChanged: {
    //   type: Function,
    //   default: () => {}
    // },
    // phone
    phone: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    phoneRegionCode: {
      type: String,
      default: 'CN',
      validator (val) {
        return ['CN', 'HK', 'TW', 'US', 'JP'].includes(val)
      }
    },
    // time
    time: {
      type: Boolean,
      default: false
    },
    timePattern: {
      type: Array,
      default: () => ['h', 'm', 's']
    },
    timeFormat: {
      type: Number,
      default: 24,
      validator (val) {
        return [12, 24].includes(val)
      }
    },
    // timeFormatter: {
    //   type: Object,
    //   default: () => {}
    // },
    // date
    date: {
      type: Boolean,
      default: false
    },
    datePattern: {
      type: Array,
      default: () => ['Y', 'm', 'd']
    },
    // dateFormatter: {
    //   type: Object,
    //   default: () => {}
    // },
    // numeral
    numeral: {
      type: Boolean,
      default: false
    },
    numeralThousandsGroupStyle: {
      type: String,
      default: 'thousand',
      validator (val) {
        return ['thousand', 'lakh', 'wan', 'none'].includes(val)
      }
    },
    // eslint-disable-next-line
    numeralIntegerScale: {
      type: Number,
      validator (val) {
        return val >= 0
      }
    },
    numeralDecimalScale: {
      type: Number,
      default: 2,
      validator (val) {
        return val >= 0
      }
    },
    numeralDecimalMark: {
      type: String,
      default: '.'
    },
    numeralPositiveOnly: {
      type: Boolean,
      default: false
    },
    stripLeadingZeroes: {
      type: Boolean,
      default: true
    },
    blocks: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line
    delimiter: {
      type: String
    },
    delimiters: {
      type: Array,
      default: () => []
    },
    delimiterLazyShow: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: ''
    },
    noImmediatePrefix: {
      type: Boolean,
      default: false
    },
    rawValueTrimPrefix: {
      type: Boolean,
      default: false
    },
    numericOnly: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    lowercase: {
      type: Boolean,
      default: false
    }
    // copyDelimiter: {
    //   type: Boolean,
    //   default: false
    // },
    // onValueChanged: {
    //   type: Function,
    //   default: () => {}
    // }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      creditCardType: '',
      maxLength: 0,
      backspace: false,
      result: '',
      isAndroid: false,
      cursorPosition: 0,
      initCreditCardType: '',
      phoneFormatterInstance: null,
      dateFormatterInstance: null,
      timeFormatterInstance: null,
      numeralFormatterInstance: null,
      initBlocks: [],
      blocksLength: 0,
      phoneType: phoneType
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    initNumericOnly () {
      return this.creditCard || this.date || !!this.numericOnly
    },
    prefixLength () {
      return this.prefix && this.prefix.length ? this.prefix.length : 0
    },
    initDelimiter () {
      return (this.delimiter || this.delimiter === '') ? this.delimiter : (this.date ? '/' : (this.time ? ':' : (this.numeral ? ',' : (this.phone ? ' ' : ' '))))
    },
    delimiterLength () {
      return this.initDelimiter.length
    },
    root () {
      return (typeof global === 'object' && global) ? global : window
    },
    document () {
      return this.root.document
    },
    wrapClasses () {
      return [`${this.prefixCls}-wrapper`]
    },
    inputClasses () {
      return [
        `${this.prefixCls}`,
        {
          [`${this.prefixCls}--${this.size}`]: !!this.size,
          [`${this.prefixCls}--disabled`]: this.disabled
        }
      ]
    }
  },
  mounted() {
    this.initCreditCardType = this.creditCardType
    this.initBlocks = this.blocks || []
    this.blocksLength = this.blocks.length
    this.$_init()
    if (this.autofocus) {
      this.$nextTick(() => {
        this.focus()
      })
    }
  },
  beforeUpdate() {
    let phoneRegionCode = this.phoneRegionCode || null
    let newValue = this.value

    if (newValue !== undefined) {
      newValue = newValue.toString()

      if (newValue !== this.result) {
        this.model = newValue
        this.$_onInput(newValue, false)
      }
    }

    // update phone region code
    if (phoneRegionCode && phoneRegionCode !== this.phoneRegionCode) {
      this.phoneRegionCode = phoneRegionCode
      this.$_initPhoneFormatter()
      this.$_onInput(this.result)
    }
  },
  updated() {
    Util.setSelection(this.$refs.element, this.cursorPosition, this.document)
  },
  methods: {
    focus() {
      this.$refs['element'].focus()
    },
    $_init () {
      if (!this.numeral && !this.phone && !this.creditCard && !this.time && !this.date && (this.blocksLength === 0 && !this.prefix)) {
        this.$_onInput(this.model)
        this.$emit('on-format-input-init')
        return false
      }
      this.maxLength = Util.getMaxLength(this.blocks)
      this.isAndroid = Util.isAndroid()
      this.$_initPhoneFormatter()
      this.$_initDateFormatter()
      this.$_initTimeFormatter()
      this.$_initNumeralFormatter()

      // avoid touch input field if value is null
      // otherwise Firefox will add red box-shadow for <input required />
      if (this.model || (this.prefix && !this.noImmediatePrefix)) {
        this.$_onInput(this.model)
      }

      this.$emit('on-format-input-init')
    },
    $_initPhoneFormatter () {
      if (!this.phone) {
        return
      }

      // Cleave.AsYouTypeFormatter should be provided by
      // external google closure lib
      try {
        this.phoneFormatterInstance = new PhoneFormatter(
          new this.root.Cleave.AsYouTypeFormatter(this.phoneRegionCode),
          this.initDelimiter
        )
      } catch (ex) {
        throw new Error('Please include phone-type-formatter.{country}.js lib')
      }
    },
    $_initDateFormatter () {
      if (!this.date) {
        return
      }

      this.dateFormatterInstance = new DateFormatter(this.datePattern)
      this.initBlocks = this.dateFormatterInstance.getBlocks()
      this.blocksLength = this.initBlocks.length
      this.maxLength = Util.getMaxLength(this.initBlocks)
    },
    $_initTimeFormatter () {
      if (!this.time) {
        return
      }

      this.timeFormatterInstance = new TimeFormatter(this.timePattern, this.timeFormat)
      this.initBlocks = this.timeFormatterInstance.getBlocks()
      this.blocksLength = this.initBlocks.length
      this.maxLength = Util.getMaxLength(this.initBlocks)
    },
    $_initNumeralFormatter () {
      if (!this.numeral) {
        return
      }
      this.numeralFormatterInstance = new NumeralFormatter(
        this.numeralDecimalMark,
        this.numeralIntegerScale,
        this.numeralDecimalScale,
        this.numeralThousandsGroupStyle,
        this.numeralPositiveOnly,
        this.stripLeadingZeroes,
        this.initDelimiter
      )
    },
    $_onInput (value, fromProps) {
      // case 1: delete one more character "4"
      // 1234*| -> hit backspace -> 123|
      // case 2: last character is not delimiter which is:
      // 12|34* -> hit backspace -> 1|34*
      const postDelimiterAfter = Util.getPostDelimiter(value, this.initDelimiter, this.delimiters)
      if (!fromProps && !this.numeral && this.postDelimiterBackspace && !postDelimiterAfter) {
        value = Util.headStr(value, value.length - this.postDelimiterBackspace.length)
      }
      // phone formatter
      if (this.phone) {
        if (this.prefix && (!this.noImmediatePrefix || value.length)) {
          this.result = this.prefix + this.phoneFormatterInstance.format(value).slice(this.prefix.length)
        } else {
          this.result = this.phoneFormatterInstance.format(value)
        }
        this.$_updateValueState()

        return false
      }

      // numeral formatter
      if (this.numeral) {
        if (this.prefix && (!this.noImmediatePrefix || value.length)) {
          this.result = this.prefix + this.numeralFormatterInstance.format(value)
        } else {
          this.result = this.numeralFormatterInstance.format(value)
        }
        this.$_updateValueState()

        return false
      }

      // date
      if (this.date) {
        value = this.dateFormatterInstance.getValidatedDate(value)
      }

      // time
      if (this.time) {
        value = this.timeFormatterInstance.getValidatedTime(value)
      }

      // strip delimiters
      value = Util.stripDelimiters(value, this.initDelimiter, this.delimiters)

      // strip prefix
      value = Util.getPrefixStrippedValue(value, this.prefix, this.prefixLength, this.result, this.initDelimiter, this.delimiters)

      // strip non-numeric characters
      value = this.initNumericOnly ? Util.strip(value, /[^\d]/g) : value

      // convert case
      value = this.uppercase ? value.toUpperCase() : value
      value = this.lowercase ? value.toLowerCase() : value

      // prefix
      if (this.prefix && (!this.noImmediatePrefix || value.length)) {
        value = this.prefix + value

        // no blocks specified, no need to do formatting
        if (this.blocksLength === 0) {
          this.result = value
          this.$_updateValueState()

          return false
        }
      }

      // update credit card props
      if (this.creditCard) {
        this.$_updateCreditCardPropsByValue(value)
      }

      // strip over length characters
      value = this.maxLength > 0 ? Util.headStr(value, this.maxLength) : value

      // apply blocks
      this.result = Util.getFormattedValue(
        value,
        this.initBlocks, this.blocksLength,
        this.initDelimiter, this.delimiters, this.delimiterLazyShow
      )

      this.$_updateValueState()
    },
    $_updateValueState () {
      if (!this.$refs.element) {
        this.model = this.result
      }

      let endPos = this.$refs.element.selectionEnd
      let oldValue = this.$refs.element.value
      let newValue = this.result

      this.lastInputValue = newValue

      endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, this.initDelimiter, this.delimiters)

      if (this.isAndroid) {
        window.setTimeout(function () {
          this.model = newValue
          this.cursorPosition = endPos
        }, 1)

        return
      }

      this.model = newValue
      this.cursorPosition = endPos
    },
    $_updateCreditCardPropsByValue (value) {
      let creditCardInfo = null

      // At least one of the first 4 characters has changed
      if (Util.headStr(this.result, 4) === Util.headStr(value, 4)) {
        return
      }

      creditCardInfo = CreditCardDetector.getInfo(value, this.creditCardStrictMode)

      this.initBlocks = creditCardInfo.blocks
      this.blocksLength = this.initBlocks.length
      this.maxLength = Util.getMaxLength(this.initBlocks)

      // credit card type changed
      if (this.initCreditCardType !== creditCardInfo.type) {
        this.initCreditCardType = creditCardInfo.type
        // this.onCreditCardTypeChanged(this.initCreditCardType)
      }
    },
    setRawValue (value) {
      value = value !== undefined && value !== null ? value.toString() : ''

      if (this.numeral) {
        value = value.replace('.', this.numeralDecimalMark)
      }

      this.postDelimiterBackspace = false

      this.onChange({
        target: { value: value },

        // Methods to better resemble a SyntheticEvent
        stopPropagation: Util.noop,
        preventDefault: Util.noop,
        persist: Util.noop
      })
    },

    getRawValue () {
      let rawValue = this.result
      if (this.rawValueTrimPrefix) {
        rawValue = Util.getPrefixStrippedValue(rawValue, this.prefix, this.prefixLength, this.result, this.initDelimiter, this.delimiters)
      }

      if (this.numeral) {
        rawValue = this.numeralFormatterInstance ? this.numeralFormatterInstance.getRawValue(rawValue) : ''
      } else {
        rawValue = Util.stripDelimiters(rawValue, this.initDelimiter, this.delimiters)
      }
      return rawValue
    },
    getISOFormatDate () {
      return this.date ? this.dateFormatterInstance.getISOFormatDate() : ''
    },
    getISOFormatTime () {
      return this.time ? this.timeFormatterInstance.getISOFormatTime() : ''
    },
    $_onKeyDown (event) {
      let charCode = event.which || event.keyCode

      // if we got any charCode === 8, this means, that this device correctly
      // sends backspace keys in event, so we do not need to apply any hacks
      this.hasBackspaceSupport = this.hasBackspaceSupport || charCode === 8
      if (!this.hasBackspaceSupport && Util.isAndroidBackspaceKeydown(this.lastInputValue, this.result)) {
        charCode = 8
      }

      // hit backspace when last character is delimiter
      var postDelimiter = Util.getPostDelimiter(this.result, this.initDelimiter, this.delimiters)
      if (charCode === 8 && postDelimiter) {
        this.postDelimiterBackspace = postDelimiter
      } else {
        this.postDelimiterBackspace = false
      }
      this.$emit('on-format-input-keydown', event)
    },
    $_onChange (event) {
      this.$_onInput(event.target.value)
      event.target.rawValue = this.getRawValue()
      event.target.value = this.result
      this.$emit('on-format-input-change', event)
      this.dispatch('TFormItem', 'g-on-form-change', event.target.value)
    },
    // $_onFocus(event) {
    //   this.$emit('focus', event)
    // },
    $_onFocus (event) {
      event.target.rawValue = this.getRawValue()
      event.target.value = this.result
      this.$emit('on-format-input-focus', event)
      Util.fixPrefixCursor(this.$refs.element, this.prefix, this.initDelimiter, this.delimiters)
    },
    $_onBlur () {
      event.target.rawValue = this.getRawValue()
      event.target.value = this.result
      this.$emit('on-format-input-blur', event)
      // NOTE: 用于form验证
      this.dispatch('TFormItem', 'g-on-form-blur', event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/format-input/index.vue